import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { getCurrentOrganization } from '../../../ducks/users'
import { fetchActions, getActions, getLoading } from '../../../ducks/actions'
import Card from '../../Shared/Card'
import Button from '../../Shared/Button'
import Header from '../../Shared/Header'
import EmptyState from '../../Shared/EmptyState'
import { FullScreenLoader } from '../../Shared/Loading'

import styles from './List.module.css'

export function ActionCard({ action }) {
  const { id, name } = action

  return (
    <Card>
      <div className={styles.item}>
        <h2>
          <Link to={`/actions/${id}`}>
            <span className={styles.name}>{name}</span>
          </Link>
        </h2>
        <Button to={`/actions/${id}/run`} icon="run">
          Run
        </Button>
      </div>
    </Card>
  )
}

export function DraftCard({ action }) {
  const { id, name } = action

  return (
    <Card>
      <div className={styles.item}>
        <h2>
          <Link to={`/actions/${id}/configure`}>
            <span className={styles.name}>{name}</span>
          </Link>
        </h2>
        <Button color="grey" to={`/actions/${id}/configure`} icon="edit">
          Edit
        </Button>
      </div>
    </Card>
  )
}

export default function ActionsList() {
  const currentOrg = useSelector(getCurrentOrganization)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchActions(currentOrg.id))
  }, [currentOrg, dispatch])

  const actions = useSelector(getActions(currentOrg.id))
  const drafts = useSelector(getActions(currentOrg.id, true))
  const loading = useSelector(getLoading)

  const empty = actions.length === 0 && drafts.length === 0

  if (loading && empty) {
    return <FullScreenLoader />
  } else if (empty) {
    return (
      <EmptyState>
        <h2>No actions yet!</h2>
        <Button icon="add" to="/actions/new">
          Create Action
        </Button>
      </EmptyState>
    )
  }

  return (
    <div>
      <Header text="Actions" />
      {actions.length > 0 ? (
        <div className={styles.list}>
          {actions.map(action => (
            <ActionCard key={action.id} action={action} />
          ))}
        </div>
      ) : (
        <EmptyState tight>
          <h2>No live actions yet!</h2>
        </EmptyState>
      )}
      {drafts.length > 0 && (
        <div className={styles.drafts}>
          <Header component="h2" text="Drafts" />
          <div className={styles.list}>
            {drafts.map(action => (
              <DraftCard key={action.id} action={action} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
